import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';
import { postRequest as post } from '../utils/HttpMethods';
import * as Sentry from '@sentry/react';
import { Fax } from 'interfaces';
import { useNotification } from '@refinedev/core';
import { faxQueryKeys } from 'api/resource/fax';

const resendFax = async ({ faxID }: { faxID: string }): Promise<void> => {
  await post('QBilling', '/action/fax/resend', {
    faxID,
  });
};

export const useResendFax = (): UseMutationResult<void> => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: resendFax,
    onError: (error) => {
      Sentry.captureException(error);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: faxQueryKeys.all,
      });
    },
  });
};

const sendFax = async ({ faxData }: { faxData: Fax }): Promise<void> => {
  await post('QBilling', '/action/fax', { ...faxData });
};

export const useSendFax = (): UseMutationResult<void> => {
  const { open } = useNotification();

  return useMutation({
    mutationFn: sendFax,
    onError: (error) => {
      Sentry.captureException(error);
      open({
        message: 'Failed to send fax',
        type: 'error',
      });
    },
    onSuccess: () => {
      open({
        message: 'Fax sent successfully',
        type: 'success',
      });
    },
  });
};
